import { Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

export const CustomTooltip = ({ label }: { label: string }) => (
  <Tooltip label={label} withArrow>
    <IconInfoCircle
      size={18}
      style={{ marginLeft: 6, cursor: 'pointer', opacity: 0.6, flexShrink: 0 }}
      stroke={1.8}
    />
  </Tooltip>
);
